export default {
    en: 'https://en.cancer.org.il',
    he: null,
    ar: 'https://ar.cancer.org.il',
    ru: 'https://ru.cancer.org.il'
};
